import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { SubscriptionTier } from "@stockuj/types";

interface SubscriptionData {
  tier: SubscriptionTier;
  isFounder: boolean;
  hasProAccess: boolean;
}

// Tiers that unlock Pro features. Must match DB enum subscription_tier.
const PRO_TIERS: SubscriptionTier[] = ["pro", "chain", "founding"];

export function useSubscription(organizationId: string | undefined) {
  return useQuery<SubscriptionData>({
    queryKey: ["subscription", organizationId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("org_effective_tier", {
        p_org_id: organizationId!,
      });

      if (error) throw error;

      // org_effective_tier returns a subscription_tier enum value
      // ('starter' | 'pro' | 'chain' | 'founding'), defaulting to 'starter'
      const tier = (data as SubscriptionTier) ?? "starter";
      const isFounder = tier === "founding";
      const hasProAccess = PRO_TIERS.includes(tier);

      return { tier, isFounder, hasProAccess };
    },
    enabled: !!organizationId,
  });
}
